import request from "@/CommonDP/utils/request";
export default {
  // 获取应用列表
  getAppList() {
    return request.get("/platformApp/group/list").then((res) => res);
  },
  getOnlyChildMemuShowList(appCode) {
    return request.get(`/admin/permission/app/getPermissionIsShowMenu?appCode=${appCode}`).then((res) => res);
  },
  setOnlyChildMemuShowList(appCode, show) {
    return request.post(`/admin/permission/app/updatePermissionIsShowMenu?appCode=${appCode}&isShowChildren=${show}`).then((res) => res);
  },
  changeGroup(parentAppCode, appCodes) {
    return request.post(`/platformApp/app/moveIn/batch`, { parentAppCode, appCodes }).then((res) => res);
  },
  queryPermissionTree(appCode) {
    return request.get(`/admin/permission/app/queryPermissionTree?appCode=${appCode}`).then((res) => res);
  },
  queryAllAppPermissionTree() {
    return request.get(`/admin/permission/application/queryPermissionTree`).then((res) => res);
  },
  // 修改应用名称
  updateAppName(id, params) {
    return request.post(`/platformApp/update/${id}`, params).then((res) => res);
  },
  // 删除应用
  deleteApp(id) {
    return request.post(`/platformApp/delete/${id}`).then((res) => res);
  },
  // 添加应用
  addApp(params) {
    return request.post("/platformApp/add", params).then((res) => res);
  },
  // 更新应用排序
  updateAppOrder(id, order) {
    return request.post(`/platformApp/move/${id}/${order}`).then((res) => res);
  },
};
